import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import NavBar from "./NavBar";
import Carousel from "./Carousel";
import Feature from "./Feature";
import ScheduleTable from "./Schedule";
import Footer from "./Footer";
import WhatsAppChat from "./Whatsapp";
import Home from "./Home"; // Yeh tumhara home page hoga
import Instantcash from "./Pages/Instantcash";
import Buybacks from "./Pages/Buybacks";
import WeSellPage from "./Pages/Wesell";
import Pawnbroking from "./Pages/Pawnbroking";
import ContactUs from "./Pages/Contact";
import RightCashComplaints from "./Pages/Complaints";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
// import About from "./pages/About"; // About page
// import Contact from "./pages/Contact"; // Contact page

const root = ReactDOM.createRoot(document.getElementById("wrapper"));
root.render(
  <React.StrictMode>
    <Router>
      <NavBar />
      <WhatsAppChat />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/instant-cash" element={<Instantcash />} />
        <Route path="/buybacks" element={<Buybacks />} />
        <Route path="/we-sell" element={<WeSellPage />} />
        <Route path="/pawn-broking" element={<Pawnbroking />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route
          path="/pawnbroking-complaints-handling-procedure"
          element={<RightCashComplaints />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* <Route path="/contact" element={<Contact />} /> */}
      </Routes>
      <Footer />
    </Router>
  </React.StrictMode>
);

reportWebVitals();
